import { inject } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { ConfirmService } from 'excellence-ui';

export const unsavedChangesGuard = async (component: { form: () => { dirty: () => boolean } }) => {
  if (!component.form().dirty()) {
    return true;
  }
  const translocoService = inject(TranslocoService);
  return await inject(ConfirmService).confirm({
    allowCancel: true,
    icon: 'heroInformationCircle',
    cancelButtonText: translocoService.translate('cockpit.parseRequests.leaveWarning.cancelButton'),
    confirmButtonText: translocoService.translate(
      'cockpit.parseRequests.leaveWarning.confirmButton',
    ),
    title: translocoService.translate('cockpit.parseRequests.leaveWarning.title'),
  });
};
